import { Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Api from "utils/services/Api";
import EndPoints from "utils/services/EndPoints";
import { getCodigoIfip } from "utils/Common";
import SelectWithServerData from "components/Select/SelectWithServerData";
import { useSnackbar } from "notistack";
import ListaMovimientos from "./ListaMovimientos";

const EstadoCuenta = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [codigoSocio, setCodigoSocio] = useState("");
  const [numeroCuenta, setNumeroCuenta] = useState("");
  const [datosCuenta, setDatosCuenta] = useState({});

  const handleSearchCuenta = useCallback(async () => {
    try {
      const response = await Api(`${EndPoints.obtieneDatosCuenta}/${numeroCuenta}`,
        "GET",
        null
      )
      if (response.codigo === 0) {
        enqueueSnackbar("No existe datos de la cuenta ingresada.", { variant: "warning" })
      } else {
        setDatosCuenta({
          numeroIdentificacion: response.personMs.numeroIdentificacion,
          nombres: response.personMs.nombres,
          saldoDisponible: response.saldoDisponible,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" })
    }
  }, [enqueueSnackbar, numeroCuenta]);

  useEffect(() => {
    if (numeroCuenta) {
      handleSearchCuenta()
    }
  }, [numeroCuenta, handleSearchCuenta])

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={8} md={6}>
          <Typography variant="h2">
            ESTADO DE CUENTA SOCIO
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <SelectWithServerData
                    label="Listado Socios"
                    endpoint={EndPoints.listadoSocio + "/" + getCodigoIfip()}
                    value={codigoSocio}
                    onChange={(_, { props: { value } }) => {
                      setCodigoSocio(value)
                      setNumeroCuenta("")
                      setDatosCuenta({})
                    }}
                    mapper={({ codigo, personaMs: { numeroIdentificacion, nombres } }) => ({
                      value: codigo,
                      label: `${numeroIdentificacion} - ${nombres.toUpperCase()}`,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SelectWithServerData
                    label="Listado Cuentas"
                    endpoint={codigoSocio ? `${EndPoints.listadoCuentas}/${codigoSocio}/${getCodigoIfip()}` : ""}
                    value={numeroCuenta}
                    onChange={(_, { props: { value } }) => {
                      setNumeroCuenta(value)
                    }}
                    mapper={({ numeroCuenta, productoMs: { descripcion } }) => ({
                      value: numeroCuenta,
                      label: `${numeroCuenta} - ${descripcion}`,
                    })}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Numero Identificación"
                    value={datosCuenta?.numeroIdentificacion ?? ""}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Nombre Socio"
                    value={datosCuenta?.nombres ?? ""}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Numero Cuenta"
                    value={numeroCuenta}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Saldo Disponible"
                    value={datosCuenta?.saldoDisponible ?? ""}
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {
                    numeroCuenta && (
                      <ListaMovimientos numeroCuenta={numeroCuenta} />
                    )
                  }
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default EstadoCuenta